module.exports = __webpack_public_path__ + "static/5-a082c319c243821d2a14f1d55f87d37b.svg";